<template>
    <div class="taskItem clearfix">
        <div class="ItemLeft">
            <div class="circle-progress"
                 style="float: left;cursor: pointer;">
                <div class="num" title="点击更新细则进度" v-if="detail.creator==this.login_user_id">
                    <div @click="updateProgress(detail)"
                         class="circle_Percent"
                         style="position: relative">
                        <div class="circleProgress">
                            <div :class="classObject(detail.rate_of_progress)">
                                <div class="circleLeft"></div>
                                <div class="circleRight"></div>
                            </div>
                        </div>
                    </div>
                </div>
               <div class="num" title="细则进度" v-if="detail.creator!=this.login_user_id">
                    <div  class="circle_Percent"
                         style="position: relative">
                        <div class="circleProgress">
                            <div :class="classObject(detail.rate_of_progress)">
                                <div class="circleLeft"></div>
                                <div class="circleRight"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="contentContainer rsq_tipBox tooltipstered">
                       <span class="ItemContent todo-item-content" v-bind:title="detail.details">
                             <router-link :to="{ name: 'planmobileinfo' , params: { id:detail.plan_id} }">
                        {{ detail.details }}
                    </router-link>
                       </span>
            <span class="typeContent" title="计划类型">{{ convertPlanType(detail.detail_type) }}</span>
            <span :class="endTimeObject(detail.end_time)" class="dateContent"
                  title="到期时间">{{ computEndTime(detail.end_time, detail.detail_type) }}</span>
            <span class="dateSet" v-if="detail.creator==this.login_user_id">
            <el-popover
                    placement="top"
                    v-model="visible"
                    width="200">
                <p>更新截止时间</p>
             <el-date-picker
                     placeholder="选择日期时间"
                     type="date"
                     v-model="detail.end_time"
                     value-format="yyyy-MM-dd">
    </el-date-picker>
  <div style="text-align: right; margin: 10px 0 0 0">
          <el-button @click="updateEndDate(detail)" size="mini" type="primary">确定</el-button>
    <el-button @click="visible = false" size="mini" type="text">取消</el-button>
  </div>
        <el-button class="el-dateSet" slot="reference" style="padding: 0" title="更新截止时间"><i
                class="fa fa-calendar-plus-o"
                style="font-size: 16px;"></i></el-button>
</el-popover>
            </span>
        </div>
    </div>
</template>

<script type="text/javascript">
import {mapActions, mapGetters, mapState} from 'vuex'
import planApi from '@/api/plan/plan_api.js'

export default {
    props: {
        detail: {
            type: Object,
            require: true,
        }
    },
    data: function () {
        return {
            isOwner:true,
            visible: false
        }
    },
    computed: {
        ...mapState({
                login_user_id: state => state.loginState.user_info.id,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({}),
        convertPlanType(detail_type) {
            if (detail_type == 'month') return '月'
            if (detail_type == 'week') return '周'
            if (detail_type == 'quarter') return '季度'
            if (detail_type == 'custom') return '自定义'
        },
        endTimeObject(endDate) {
            if (endDate) {
                let day1 = new Date(endDate)
                let day2 = new Date()
                let s2 = day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate();
                let s2day = new Date(s2)
                if (day1 < s2day) return 'delayIcon'
            }
        },
        computEndTime(endDate, detailType) {
            if (endDate) {

                let day1 = new Date(endDate)
                let day2 = new Date()
                let s2 = day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate();
                let s2day = new Date(s2)

                if (day1 >= s2day) {
                    let remainTime = (day1 - s2day) / (1000 * 60 * 60 * 24)
                    if (remainTime <= 3 && detailType == 'week') return ('剩余' + Math.floor(remainTime + 1) + '天')
                    else if (remainTime <= 10 && detailType !== 'week') return ('剩余' + Math.floor(remainTime + 1) + '天')
                    else return endDate
                } else {
                    let overTime = (day2 - day1) / (1000 * 60 * 60 * 24)
                    return ('逾期' + Math.floor(overTime) + '天')
                }
            } else return ''
        },
        classObject: function (rate) {
            if (rate == 25) return 'circle25'
            if (rate == 50) return 'circle50'
            if (rate == 75) return 'circle75'
            if (rate == 100) return 'circle100'
        },
        updateProgress: async function (detail) {
            let newProgress = detail.rate_of_progress + 25
            if (newProgress > 100) newProgress = 0
            let vals = {
                detail_id: detail.id,
                progress: newProgress,
            }
            let res = await planApi.modify_plan_detail_progress(vals)
            let data = JSON.parse(res.data.result);
            if (data.code === 'success') {
                this.$message({
                    message: data.message,
                    type: 'success'
                });
                detail.rate_of_progress = newProgress
            } else {
                this.$message({
                    message: data.message,
                    type: 'warning'
                });
            }
        },
        updateEndDate: async function (detail) {
            let vals = {
                detail_id: detail.id,
                end_date: detail.end_time,
            }

            let res = await planApi.modify_plan_detail_end_date(vals)
            let data = JSON.parse(res.data.result);
            if (data.code === 'success') {
                this.$message({
                    message: data.message,
                    type: 'success'
                });
            } else {
                this.$message({
                    message: data.message,
                    type: 'warning'
                });
            }
            this.visible = false
        }
    },
    mounted() {

    }
}
</script>

<style scoped type="text/css">

.taskItem {
    transition: all .3s;
    position: relative;
    line-height: 30px;
    height: 32px;
    background: #fff;
    border-radius: 2px;
    width: 100%;
    cursor: default;
    overflow: hidden;
    display: flex;
    border: 1px solid #eaeaea;
    border-bottom: none;
    font-size: .8125rem;
    color: #3d3d3d;
}

.ItemLeft {
    margin-top: 2px;
    background-color: inherit;
    flex: 0 0 41px;
    text-align: center;
}

.contentContainer {
    flex: 1;
    display: flex;
    overflow: hidden;
    font-size: .8125rem;
    color: #3d3d3d;
}

.ItemContent {
    display: block;
    width: 60%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.typeContent {
    display: block;
    width: 10%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.dateContent {
    display: block;
    width: 20%;
    font-size: 12px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.dateSet {
    display: block;
    width: 10%;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.delayIcon {
    font-style: normal;
    /*line-height: 40px;*/
    flex: 0 0 auto;
    color: darkred;
    font-weight: bold;
}

.clearfix:after {
    content: "";
    display: table;
    clear: both;
}

.circleProgress {
    width: 2em;
    height: 2em;
    position: relative;
}

.circleProgress .progressNum {
    position: absolute;
    width: 1.5em;
    height: 1.5em;
    background-color: white;
    border-radius: 50%;
    left: 0.25em;
    top: 0.25em;
    line-height: 1.5em;
    text-align: center;
}

.circleLeft,
.circleRight {
    width: 1em;
    height: 2em;
    overflow: hidden;
    position: relative;
    float: left;
    background-color: #1989FA;

}

.circleLeft {
    border-radius: 2em 0 0 2em;
}

.circleRight {
    border-radius: 0 2em 2em 0;
}

.circleLeft:after,
.circleRight:after {
    content: "";
    position: absolute;
    display: block;
    width: 1em;
    height: 2em;
    background-color: white;
    border-radius: 2em 0 0 2em;
    background-color: #f2f2f2;
}

.circleRight:after {
    content: "";
    position: absolute;
    display: block;
    border-radius: 0 2em 2em 0;
}

.circle25 .circleLeft:after {
    transform-origin: right center;
}

.circle25 .circleRight:after {
    transform-origin: left center;
    transform: rotateZ(90deg);
}

.circle50 .circleLeft:after {
    transform-origin: right center;
}

.circle50 .circleRight:after {
    transform-origin: left center;
    transform: rotateZ(180deg);
}

.circle75 .circleLeft:after {
    transform-origin: right center;
    transform: rotateZ(90deg);
}

.circle75 .circleRight:after {
    transform-origin: left center;
    transform: rotateZ(180deg);
}

.circle100 .circleLeft:after {
    transform-origin: right center;
    transform: rotateZ(180deg);
}

.circle100 .circleRight:after {
    transform-origin: left center;
    transform: rotateZ(180deg);
}

.num {
    position: absolute;
    text-align: center;
    font-weight: bold;
    top: 2px;
    left: 7px;
}

.contentContainer .el-dateSet {
    border: none;
}

</style>
<style>
.el-date-editor {
    width: 170px;
}

.el-date-editor .el-input__inner {
    width: 150px;
}
</style>
